import { connect } from 'react-redux';
import React from 'react';
import Header from 'presentation/selfService/Header';
import overrideStyle from 'lib/overrideStyle';

import AnswerDisplay from './AnswerDisplay';
import ChatWithAgentSection from './ChatWithAgentSection';
import { getSelectedSelfServiceAnswer } from 'app/modules';
import QuickActions from './QuickActions';

const Wrapper = overrideStyle('div')`
    background-color: white;
    border-radius: 10px;
    box-shadow: inherit;
    display: flex;
    flex-direction: column;
    height: 500px;
    max-height: calc(100vh - 30px);
    justify-content: flex-end;
    overflow: hidden;
    top: 0px;
    width: 364px;
`;

export function SelfService(props) {
  // get/load from config/store
  const colors = {
    primary: '#062158',
  };

  return (
    <Wrapper>
      {props.isAnswerSelected ? (
        <AnswerDisplay />
      ) : (
        <React.Fragment>
          <Header colors={colors} />
          <QuickActions />
        </React.Fragment>
      )}
      <ChatWithAgentSection colors={colors} />
    </Wrapper>
  );
}

const mapStateToProps = state => {
  return {
    isAnswerSelected: !!getSelectedSelfServiceAnswer(state),
  };
};

export default connect(mapStateToProps)(SelfService);
